import React, { useEffect, useState } from 'react';
import useLocales from '../../hooks/useLocales';
import { BusinessType, SteelCategory, SteelMaker } from '../../types/common';
import { RootState, useDispatch, useSelector } from '../../redux/store';
import type { ICellRendererParams } from 'ag-grid-community';
import type { OptionsType } from '../../types/options';

/**
 * OptionsTypeのリストを表示するレンダラ
 * @param params: ICellRendererParams
 * @returns React.ReactElement
 */
const OptionsTypeRenderer = (params: ICellRendererParams): React.ReactElement => {
  // console.log(params);
  const { currentLang } = useLocales();
  const { organizationBase, steelMaker, businessType, steelType, steelCategory, customer, customer1, customer2, customer3, language, tradingCompany } = useSelector(
    (state: RootState) => state.options,
  );
  // 配列ではないフィールドも配列として扱う
  // またorganizationBaseIdは number のため string にしておく必要がある（それ以外はもともと文字列になっている）
  const codes: string[] = Array.isArray(params.value) ? params.value.map((value) => String(value)) : [String(params.value)];
  const field: string | undefined = params.colDef.field;
  const [optionLabels, setOptionLabels] = useState<string>(params.valueFormatted);

  // SIDE EFFECT
  // ================================================================================

  /**
   * 確認用
   */
  // useEffect(() => {
  //   console.log(optionLabels);
  // }, [optionLabels]);

  useEffect(() => {
    if (field) {
      const labels: string[] = codes.map((code) => {
        const option: OptionsType | undefined =
          field === 'organizationBaseId'
            ? organizationBase.find((option) => option.code === code)
            : field === 'steelMaker'
            ? steelMaker.find((option) => option.code === code)
            : field === 'businessType'
            ? businessType.find((option) => option.code === code)
            : field === 'steelType'
            ? steelType.find((option) => option.code === code)
            : field === 'steelCategory'
            ? steelCategory.find((option) => option.code === code)
            : field === 'customer'
            ? customer.find((option) => option.code === code)
            : field === 'customer1'
            ? customer1.find((option) => option.code === code)
            : field === 'customer2'
            ? customer2.find((option) => option.code === code)
            : field === 'customer3'
            ? customer3.find((option) => option.code === code)
            : field === 'language'
            ? language.find((option) => option.code === code)
            : field === 'tradingCompany'
            ? tradingCompany.find((option) => option.code === code)
            : undefined;
        // console.log(option);
        if (option !== undefined) {
          const label: string = currentLang.value === 'ja' ? option.nameJapanese : option.nameEnglish ?? option.nameJapanese;
          return label;
        } else {
          return code;
        }
      });
      const labelsString: string = labels.join(', ');
      setOptionLabels(labelsString);
    } else {
      // do nothing
    }
  }, [codes, organizationBase, steelMaker, businessType, steelType, steelCategory, customer, customer1, customer2, customer3, language, tradingCompany]);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return <div className="option-options-type">{optionLabels}</div>;
};

export default OptionsTypeRenderer;
